import * as React from "react";

export default class SimpleDownloadModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            progress: 0,
            status: '',
            message: ''
        };
    }

    show = (message = 'Starting download...') => {
        try {
            this.setState({
                isVisible: true,
                progress: 0,
                status: 'Starting',
                message: message
            });
        } catch (error) {
            console.error('Error showing modal:', error);
        }
    }

    update = (progress, status, message) => {
        try {
            this.setState({
                progress: progress || 0,
                status: status || 'Processing',
                message: message || ''
            });
        } catch (error) {
            console.error('Error updating modal:', error);
        }
    }

    dismiss = () => {
        try {
            this.setState({
                isVisible: false,
                progress: 0,
                status: '',
                message: ''
            });
        } catch (error) {
            console.error('Error dismissing modal:', error);
        }
    }

    render() {
        if (!this.state.isVisible) {
            return null;
        }

        const modalOverlay = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            fontFamily: 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif'
        };

        const modalContent = {
            background: '#fff',
            borderRadius: 12,
            padding: '24px',
            maxWidth: 400,
            width: '90%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            position: 'relative'
        };

        const title = {
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            marginBottom: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        };

        const progressBar = {
            width: '100%',
            height: 8,
            backgroundColor: '#e0e7ef',
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 10
        };

        const progressFill = {
            height: '100%',
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            borderRadius: 4,
            transition: 'width 0.3s ease',
            width: `${this.state.progress}%`
        };

        const progressText = {
            fontSize: 13,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: 6
        };

        const statusText = {
            fontSize: 14,
            fontWeight: 600,
            color: '#2bbbad',
            marginBottom: 6
        };

        const messageText = {
            fontSize: 12,
            color: '#666',
            lineHeight: 1.4,
            marginBottom: 20
        };

        const closeButton = {
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'none',
            border: 'none',
            fontSize: '18px',
            color: '#999',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '50%',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        };

        const getStatusIcon = () => {
            if (this.state.status === 'Starting') return 'fa fa-play';
            if (this.state.status === 'Processing') return 'fa fa-cog fa-spin';
            if (this.state.status === 'Completed') return 'fa fa-check';
            if (this.state.status === 'Error') return 'fa fa-exclamation-triangle';
            return 'fa fa-download';
        };

        const getStatusColor = () => {
            if (this.state.status === 'Completed') return '#28a745';
            if (this.state.status === 'Error') return '#dc3545';
            return '#2bbbad';
        };

        return (
            <div style={modalOverlay}>
                <div style={modalContent}>
                    <button 
                        style={closeButton}
                        onClick={this.dismiss}
                        title="Close"
                    >
                        ×
                    </button>
                    
                    <div style={title}>
                        <span className="fa fa-download" style={{color: '#2bbbad'}}/>
                        Download Progress
                    </div>
                    
                    <div style={progressText}>
                        {this.state.progress}% Complete
                    </div>
                    <div style={progressBar}>
                        <div style={progressFill}></div>
                    </div>
                    <div style={{...statusText, color: getStatusColor()}}>
                        <span className={getStatusIcon()} style={{marginRight: 8}}/>
                        {this.state.status}
                    </div>
                    
                    <div style={messageText}>
                        {this.state.message}
                    </div>
                </div>
            </div>
        );
    }
} 